import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=6d08d67b&scoped=true&"
import script from "./BasketItem.vue?vue&type=script&lang=js&"
export * from "./BasketItem.vue?vue&type=script&lang=js&"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=6d08d67b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08d67b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
